import { EndpointSetting } from "@/lib/redux/type";
import { ProductState, TypeProductDetailNoDesign } from "../type";

export const callbackGetDesignDetail: EndpointSetting['caller'] = (
  state: ProductState,
  action: any,
  endpointName: string
) => {
  const { productDetailState, ...productDetail } = action.payload

  if (productDetail.no_design && !productDetail.bundle) {
    const _productDetail: TypeProductDetailNoDesign = productDetail
    const variants = _productDetail.variants || []

    state.product_no_design.loading = false
    state.product_no_design.called = true
    state.product_no_design.success = true
    state.product_no_design.error = null
    state.product_no_design.data = productDetail
    state.product_no_design.data.colorsVariantsMapping = {}
    state.product_no_design.data.sizesVariantsMapping = {}
    let selectedVariant: any = null
    
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      const attributes = v.attributes || []
      if (v.id === _productDetail.product_details?.default?.vid) {
        selectedVariant = v
      }
      for (let x = 0; x < attributes.length; x++) {
        const attr = attributes[x];
        let key: any = null
        if (!!attr.color) {
          const isNotTexture = attr.values?.texture === 'null' || !attr.values?.texture
          if (isNotTexture) {
            key = attr.values?.color
          } else {
            key = attr.values?.texture
          }
          if (!key) continue;
          if (!state.product_no_design.data.colorsVariantsMapping[key]) {
            state.product_no_design.data.colorsVariantsMapping[key] = [v.id]
          } else {
            state.product_no_design.data.colorsVariantsMapping[key].push(v.id)
          }
        }

        if (!!attr.size) {
          key = attr.values?.label
          if (!key) continue;
          if (!state.product_no_design.data.sizesVariantsMapping[key]) {
            state.product_no_design.data.sizesVariantsMapping[key] = [v.id]
          } else {
            state.product_no_design.data.sizesVariantsMapping[key].push(v.id)
          }
        }
        
      }
    }

    if (!selectedVariant) {
      selectedVariant = variants[0]
    }

    state.productDetailState = {
      selectedVariantId: selectedVariant?.id,
      selectedAspectLabel: _productDetail.product_details?.default?.aspect,
    }
  } else {
    state.design_detail.loading = false
    state.design_detail.called = true
    state.design_detail.success = true
    state.design_detail.error = null
    state.design_detail.data = productDetail
    state.productDetailState = productDetailState
  }
}